// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","685":"final"}[chunkId] + "." + {"594":"f60806ce","685":"ef116f61"}[chunkId] + ".js";
};